import React from 'react';
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const useStyles = ({padding}) => ({
    root: {
        lineHeight: 2,
        padding: padding ? padding : '0px',
        textAlign: "center"
    },
    img: {
        color: '#9fc7da'
    }
})


const IconLink = props => {
    const { 
            id,
            href,
            to,
            text,
            icon,
            size = '4x',
            height='40px',
            width='40px',
            onClick = () => null,
            type} = props;
    const styles = useStyles({...props})

    const linkProps = {
        onClick, href, to
    }

    const ImgContainer = ({icon, text, type, size}) => {
        return (
            <div style={styles.root}>
                <div style={styles.img}>
                    {type === 'img' && <img src={icon} height={height} width={width} alt={`${text} Link`} data-testid={`MEDICAL_RX_${text.toUpperCase()}`} />}
                    {type !== 'img' && <FontAwesomeIcon icon={icon} size={size} data-testid={`MEDICAL_RX_${text.toUpperCase()}`}/>}
                </div>
                <div>
                    {text}
                </div>
            </div>
        );
    }



    return (
        <span className="icon-link" id={id}  data-test-id={id}>
            {href ?
                <a href={href} onClick={onClick}>
                    <ImgContainer text={text} icon={icon} type={type} size={size}/>
                </a> : to ?
                        <Link {...linkProps}>
                            <ImgContainer text={text} icon={icon} type={type} size={size}/>
                        </Link>
                        : <ImgContainer text={text} icon={icon} type={type} size={size}/>
            }
        </span>
    )
};

export default IconLink;
